/* eslint-disable react/jsx-no-bind */
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import DataTable from 'src/shared/components/DataTable';
import { downloadFromUrl, showMessage } from 'src/shared/AppUtils';
import { Button } from 'antd';
import { checkPermit, getRecordContentApi } from './ApiService';
import ReadBookModal from './ReadBookModal';
// import ff from '../../asset/pdfs/tamlyhoclaodong.pdf';

const Wrapper = styled.div`
  .button:hover span,
  button:hover span {
    color: inherit;
  }
`;

function ReadBook({ id }) {
  const [fileList, setFileList] = useState([]);
  const [fileUrl, setFileUrl] = useState('');
  const [dataText, setDataText] = useState('');
  const [fileExtension, setFileExtension] = useState('');
  const [password, setPassword] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const getConent = () => {
    const params = { id, type: 'file' };
    getRecordContentApi(params).then((data) => {
      const newFileList = data?.reduce((acc, curr) => {
        acc.push(...curr.ListFiles);
        return acc;
      }, []) || [];
      setFileList(newFileList);
    });
  };

  const accessFile = useCallback((fileId, saveFileName) => {
    checkPermit(fileId).then((res) => {
      if (!res.Success) {
        let errMsg = res.Message;
        if (res.Message === 'NOT_FOUND') errMsg = 'Tài liệu này không có...';
        else if (res.Message === 'NOT_ALLOW') errMsg = 'Không có quyền...';
        else if (res.Message === 'NO_FILE') {
          errMsg = 'Lỗi không tìm thấy file trên máy chủ...';
        }
        showMessage('Thông báo', errMsg);
        return;
      }

      setFileExtension(res.Extension);
      const resFileUrl = res.FileUrl;

      if (res.Extension === 'pdf') {
        setFileUrl(resFileUrl);
        setPassword(res.Password);
        openModal();
      } else if (res.Extension === 'txt') {
        axios.get(resFileUrl).then(({ data }) => {
          setDataText(data);
          openModal();
        });
      } else {
        downloadFromUrl(resFileUrl, saveFileName);
      }
    });
  });

  const columns = [
    {
      title: 'Loại File',
      dataIndex: 'RecordFileTypeName',
      key: 'RecordFileTypeName',
    },
    {
      title: 'Tên file',
      dataIndex: 'SaveFileName',
      key: 'SaveFileName',
      render: (fileName, { RecordFileID, SaveFileName }) => (
        <Button
          type="link"
          onClick={() => accessFile(RecordFileID, SaveFileName)}
        >
          {fileName}
        </Button>
      ),
    },
  ];

  useEffect(() => {
    getConent();
  }, []);

  return (
    <Wrapper>
      <DataTable dataSource={fileList} columns={columns} />
      {isModalOpen && (
        <ReadBookModal
          isModalOpen={isModalOpen}
          handleCancel={closeModal}
          handleOk={closeModal}
          fileUrl={fileUrl}
          extension={fileExtension}
          dataText={dataText}
          password={password}
        />
      )}
    </Wrapper>
  );
}

export default ReadBook;
